var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstimate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    height: "2.22rem",
    width: "2.22rem",
    alt: "Estimate",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Estimate"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,39a1,1,0,0,0-1,1v4H2V9H9a1,1,0,0,0,1-1V2H33v9a1,1,0,0,0,2,0V1a1,1,0,0,0-1-1H9a1.16,1.16,0,0,0-.37.07.5.5,0,0,0-.12.08.59.59,0,0,0-.17.1l-8,7,0,0a1,1,0,0,0-.17.24.47.47,0,0,0-.06.09A.9.9,0,0,0,0,8V45a1,1,0,0,0,1,1H34a1,1,0,0,0,1-1V40A1,1,0,0,0,34,39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.55,46.73l-9-11A2,2,0,0,0,38.73,35l-2.17-2.8a10.45,10.45,0,1,0-1.43,1.42l2,2.61a2,2,0,0,0,.3,2l9,11A2,2,0,0,0,48,50a2,2,0,0,0,1.27-.45A2,2,0,0,0,49.55,46.73ZM25.48,29.15a.71.71,0,0,1-.35-.62.7.7,0,0,1,.71-.71.71.71,0,0,1,.43.14,4.54,4.54,0,0,0,1.91.87V26.29c-1.89-.49-2.76-1.2-2.76-2.66s1.09-2.34,2.71-2.47v-.27a.57.57,0,0,1,.56-.56.56.56,0,0,1,.56.56v.28a4.74,4.74,0,0,1,2,.71.69.69,0,0,1,.39.62.71.71,0,0,1-.72.71.72.72,0,0,1-.39-.11,4.6,4.6,0,0,0-1.33-.57V25c2,.49,2.8,1.28,2.8,2.66S30.89,30,29.25,30.19V31a.56.56,0,0,1-.56.56.57.57,0,0,1-.56-.56v-.8A5.52,5.52,0,0,1,25.48,29.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.18,22.45c-.83.08-1.24.52-1.24,1.09s.24.87,1.24,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.48,27.76c0-.57-.29-.92-1.28-1.23v2.35C30,28.79,30.48,28.38,30.48,27.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,14H22a1,1,0,0,0,0-2H6a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,20H17.29a12.33,12.33,0,0,1,1.23-2H6a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,26H16c0-.17,0-.33,0-.5a12.32,12.32,0,0,1,.1-1.5H6a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,32H17.84a12.83,12.83,0,0,1-1-2H6a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,38H22a1,1,0,0,0,0-2H6a1,1,0,0,0,0,2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimate);
export default __webpack_public_path__ + "static/media/Estimate.055560f5.svg";
export { ForwardRef as ReactComponent };